module.exports = __webpack_public_path__ + "static/media/Steve Bahmer Headshot.550600e9.jpeg";